import ContentLayout from "../../component/ContentLayout";
import { AgGridReact } from "ag-grid-react";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";
import moment from "moment/moment";
import TeamModal from "../../component/TeamModal";

const Team = () => {
  const { setError } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [teamData, setTeamData] = useState<any>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [user, setUser] = useState<any>({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    user_type: "",
  });

  const getTeamData = () => {
    setLoading(true);
    axios({
      URL: `/omw/get-admin-users`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data?.users;
        setTeamData(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getTeamData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createTeamMember = () => {
    const localData = JSON.parse(`${localStorage.getItem("user")}`);
    setLoading(true);
    const data = {
      ...user,
      active: true,
      created_by: localData?.role ? "admin" : "system",
      token: null,
      last_login_dt: null,
    };
    axios({
      URL: `/omw/create-admin-user`,
      method: "POST",
      data: data,
    })
      .then(() => {
        getTeamData();
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };
  const updateTeamMember = () => {
    setLoading(true);
    const data = {
      first_name: user?.first_name,
      last_name: user?.last_name,
      email: user?.email,
      phone: user?.phone,
      password: user?.password,
    };
    axios({
      URL: `/omw/update-admin-user/${user?.id}`,
      method: "PUT",
      data: data,
    })
      .then(() => {
        getTeamData();
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };
  const deleteTeamMember = (id: any) => {
    setLoading(true);
    axios({
      URL: `/omw/delete-admin-user/${id}`,
      method: "DELETE",
    })
      .then(() => {
        getTeamData();
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };
  const [colDefs] = useState<any>([
    {
      field: "first_name",
      headerName: "First Name",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center"}>
            <p>{param?.value}</p>
          </div>
        );
      },
    },
    {
      field: "middle_name",
      headerName: "Middle Name",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center"}>
            <p>{param?.value}</p>
          </div>
        );
      },
    },
    {
      field: "last_name",
      headerName: "Last Name",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center"}>
            <p>{param?.value}</p>
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "user_type",
      headerName: "User Type",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "created_dt",
      headerName: "Created At",
      cellRenderer: (param: any) => {
        return (
          <div
            className={
              "flex items-center justify-start flex-row gap-0.5 flex-wrap"
            }
          >
            <p className={"p-0 text-sm"}>
              {moment(param.value).format("MM-DD-yyyy")}
            </p>
            <p className={"p-0 text-sm font-bold"}>
              {moment(param.value).format("hh:mm A")}
            </p>
          </div>
        );
      },
    },
    {
      field: "created_by",
      headerName: "Created By",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "updated_by",
      headerName: "Updated By",
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      minWidth: 80,
      maxWidth: 80,
      cellRenderer: (param: any) => {
        return (
          <div
            className={
              "h-full flex flex-col items-center justify-center cursor-pointer"
            }
            onClick={() => {
              setOpenModal(true);
              setUser((pre: any) => ({ ...pre, ...param?.data }));
              setIsEdit(true);
            }}
          >
            <EditIcon className={"text-primary"} />
          </div>
        );
      },
    },
    {
      field: "name",
      headerName: "Delete",
      minWidth: 80,
      maxWidth: 80,
      cellRenderer: (param: any) => {
        return (
          <div
            className={
              "h-full flex flex-col items-center justify-center cursor-pointer"
            }
            onClick={() => deleteTeamMember(param?.data?.id)}
          >
            <CloseIcon className={"text-red-600"} />
          </div>
        );
      },
    },
  ]);

  return (
    <ContentLayout className={"items-start"}>
      <div
        className={
          "flex sm:flex-row flex-col w-full justify-between items-center gap-2"
        }
      >
        <p className={"text-3xl font-bold text-secondary"}>Team Members</p>
        <button
          className={
            "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md w-full sm:w-auto"
          }
          onClick={() => setOpenModal(!openModal)}
        >
          Create Team Member
        </button>
      </div>
      <div className="bg-white w-full mt-8 rounded-lg">
        <div className="ag-theme-quartz w-full" style={{ height: 670 }}>
          <AgGridReact
            // loading={loading}
            rowData={teamData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            // pagination={pagination}
            // paginationPageSize={pageSize}
            // paginationPageSizeSelector={paginationPageSizeSelector}
            suppressRowClickSelection={true}
            // onPaginationChanged={(event) => onPageChange(event)}
          />
        </div>
      </div>
      <TeamModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setIsEdit(false);
          setUser({
            first_name: "",
            middle_name: "",
            last_name: "",
            email: "",
            phone: "",
            password: "",
            user_type: "",
          });
        }}
        user={user}
        setUser={setUser}
        onSubmit={() => {
          if (isEdit) {
            updateTeamMember();
          } else {
            createTeamMember();
          }
        }}
        isEdit={isEdit}
      />
    </ContentLayout>
  );
};
export default Team;
